import { Component, OnInit } from "@angular/core";
import { filter } from "rxjs/operators";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/public_api";
import { PedidoService } from "src/app/core/services/pedido-service";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import { InitProvider } from "src/app/core/services/init-provider";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { OrderClient } from "src/app/core/entities/orderClient";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { LogService } from "src/app/core/services/log-service";
import { formatDate, Location } from "@angular/common";
import { ToastrService } from "ngx-toastr";

declare var $: any;

@Component({
  selector: "app-page-new-order",
  templateUrl: "./page-new-order.component.html",
  styleUrls: ["./page-new-order.component.css"],
})
export class PageNewOrderComponent implements OnInit {
  SITE: ConfiguracoesSite;
  abrePedidoEmGrupo: boolean;

  public error: Boolean = false;
  public errorMsg: String[] = [];
  public form: FormGroup;
  public abrindoPedido = false;
  isCopy: boolean = false
  term: string = "";
  tipoSelecionado: any;
  noResult = false;
  selectedCliente: any;
  listCliente: any = [];
  tabelas: any = [];
  public dateFormat = $localize`DD/MM/YYYY`
  pedidoTiposUsuario: any = [];
  /** Evita que setValue programático da filial dispare carga duplicada de tabelas. */
  aplicandoDadosCliente = false;
  /** Cache getTabelas por cliente + filial (evita nova requisição ao reabrir o mesmo cliente no badge). */
  tabelasPorClienteFilial = new Map<string, any[]>();
  clienteDetail: any = {};

  filiais: any = [];
  filial_Estoque: any = [];
  errorClienteTabela = false;
  errorClienteBloqueado = false;

  dataEntregaMinDate: Date;
  dataEntregaDaysDisable = [];
  clienteIdErp = {};
  pedidoOriginal;
  erroMensagemBloqueio: any;
  cidades?: any;

  get abrirPedidoDisabled(): boolean {
    return (
      this.listCliente.length < 1 ||
      this.abrindoPedido ||
      !!this.pedidoService.loading
    );
  }

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private initProvider: InitProvider,
    private usuarioService: UsuarioService,
    private localeService: BsLocaleService,
    private pedidoService: PedidoService,
    private logService: LogService,
    private activeRoute: ActivatedRoute,
    public toastService: ToastrService,
    private location: Location
  ) {
    this.selectedCliente = {}
    this.isCopy = this.router.url === "/copia-pedido"
    this.SITE = Configuracoes.SITE;
    this.abrePedidoEmGrupo = Configuracoes.abrePedidoEmGrupo
    this.dataEntregaMinDate = new Date();
    this.tipoSelecionado = "";

    if (
      this.dataEntregaMinDate.getHours() > this.SITE.dataEntregaHorarioLimite
    ) {
      this.dataEntregaMinDate.setDate(
        this.dataEntregaMinDate.getDate() +
        1 +
        this.SITE.dataEntregaCarenciaPrazo
      );
    } else {
      this.dataEntregaMinDate.setDate(
        this.dataEntregaMinDate.getDate() + this.SITE.dataEntregaCarenciaPrazo
      );
    }
    this.dataEntregaDaysDisable = JSON.parse(
      "[" + this.SITE.dataEntregaDiasDesabilitados + "]"
    );
    this.localeService.use("pt-custom");

    // this.filiais = initProvider.filiais;
    this.form = this.formBuilder.group({
      tabela: ["", Validators.required],
      pedidoTipo: ["", Validators.required],
      filialEstoque: [""],
    });
    if (this.SITE.mostraDataEntrega) {
      this.form.addControl(
        "dataEntrega",
        new FormControl("", [Validators.required])
      );
    }
    if (this.isCopy) {
      this.form.addControl("observacao", new FormControl(""));
    }
    if (this.filiais.length === 1) {
      this.form.addControl(
        "filial",
        new FormControl(this.filiais[0].id, [Validators.required])
      );
      this.selecionaFilial(this.filiais[0].id);
    } else {
      this.form.addControl(
        "filial",
        new FormControl("", [Validators.required])
      );
    }

    this.pedidoOriginal = this.router.getCurrentNavigation().extras.state;

    if (this.pedidoOriginal) {
      for (let cliente_ in this.pedidoOriginal.clientes) {
        this.selecionaCliente(this.pedidoOriginal.clientes[cliente_].cliente);
        $("#cliente").val("");
      }

      this.form.controls["tabela"].setValue(this.pedidoOriginal.tabela.id);
      this.form.controls["pedidoTipo"].setValue(this.pedidoOriginal.tipo.id);

      if (
        this.pedidoOriginal.dataEntrega &&
        this.pedidoOriginal.dataEntrega != null
      )
        this.form.controls["dataEntrega"].setValue(
          this.pedidoOriginal.dataEntrega
        );
    }
  }

  results: string[] = [];

  buscandoClientes = false;

  /** Enquanto busca detalhes (getClientesId) após escolher um cliente na lista. */
  clienteDetalheCarregando = false;

  get clienteSelecionado(): boolean {
    return !!this.selectedCliente && !!this.selectedCliente.id;
  }

  get copyAccent(): string {
    return this.SITE?.backgroundColorSliderSuperior || "";
  }

  get clienteDocumento(): string {
    return this.documentoCliente(this.selectedCliente);
  }

  documentoCliente(c: any): string {
    if (!c) {
      return "";
    }
    const bruto =
      c.cnpj ||
      c.cpfCnpj ||
      c.documento ||
      c.cgc ||
      c[this.SITE?.identificacaoCliente] ||
      "";
    return this.formatarDocumento(bruto);
  }

  private formatarDocumento(valor: any): string {
    const texto = String(valor || "").trim();
    const digitos = texto.replace(/\D/g, "");
    if (digitos.length === 14) {
      return digitos.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    }
    if (digitos.length === 11) {
      return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    return texto;
  }

  textoEndereco(a: any): string {
    if (!a) {
      return "";
    }
    return `${a.endereco || ""} ${a.numero || ""}`.trim();
  }

  textoEnderecoComplemento(a: any): string {
    if (!a) {
      return "";
    }
    const cidade = a.descricao || a.nomecidade || "";
    const uf = a.uf && a.uf !== "0" ? a.uf : "";
    const local = [cidade, uf].filter(Boolean).join(" - ");
    const partes = [a.bairro, local, a.cep].filter((p) => p && String(p).trim());
    return partes.join(" · ");
  }

  get clienteIntegrado(): boolean {
    const c: any = this.selectedCliente;
    if (!c || !c.id) {
      return true;
    }
    return Array.isArray(c.enderecos) && c.enderecos.length > 0;
  }

  private static readonly BUSCA_MIN = 2;

  private debounceTimer: any;
  private lastParams = "";

  private debounceBuscarClientes(params: { busca: string; id_usuario: any }) {
    clearTimeout(this.debounceTimer);
    this.buscandoClientes = true;
    this.debounceTimer = setTimeout(() => {
      const p = JSON.stringify(params);
      if (p !== this.lastParams) {
        this.lastParams = p;
        this.usuarioService.getClientes(
          params,
          function (resp) {
            this.results = resp;
            this.buscandoClientes = false;
          }.bind(this)
        );
      } else {
        this.buscandoClientes = false;
      }
    }, 0);
  }

  /**
   * Busca automática: após 1s sem digitar (typeahead) + mín. 2 caracteres.
   * Botão Buscar força com 2+ caracteres.
   */
  searchFunction = async (value: string, forceSearch = false) => {
    const v = (value ?? "").trim();
    if (!v) {
      this.results = [];
      this.buscandoClientes = false;
      this.lastParams = "";
      return;
    }
    if (!forceSearch && v.length < PageNewOrderComponent.BUSCA_MIN) {
      this.buscandoClientes = false;
      return;
    }
    this.debounceBuscarClientes({
      busca: v,
      id_usuario: this.initProvider.usuario.id,
    });
  };

  handleSelection = (value: string) => {
    this.selecionaCliente(value);
    this.results = []
  };

  handleSelectionCopy = (value: string) => {
    this.selecionaClienteCopy(value);
    this.results = []
  };

  select(param) {
    this.clienteIdErp[this.selectedCliente.id] = param;
  }

  private chaveCacheTabelas(clienteId: any, filialId: any): string {
    return `${clienteId}_${String(filialId)}`;
  }

  private invalidarCacheTabelasCliente(clienteId: any) {
    const prefix = `${clienteId}_`;
    for (const key of [...this.tabelasPorClienteFilial.keys()]) {
      if (key.startsWith(prefix)) {
        this.tabelasPorClienteFilial.delete(key);
      }
    }
  }

  private clienteDetalhadoEmMemoria(c: any): boolean {
    return (
      Array.isArray(c?.filiais) &&
      Array.isArray(c?.filial_estoque) &&
      Array.isArray(c?.enderecos)
    );
  }

  compareIds = (a: any, b: any): boolean =>
    a === b || String(a ?? "") === String(b ?? "");

  private tabelaOrigemCopia(): any {
    return this.pedidoService.pedidoCopy?.tabela || null;
  }

  private normalizarListaTabelas(res: any): any[] {
    if (Array.isArray(res)) {
      return res.slice();
    }
    if (Array.isArray(res?.content)) {
      return res.content.slice();
    }
    if (Array.isArray(res?.tabelas)) {
      return res.tabelas.slice();
    }
    return [];
  }

  private selecionarTabelaOrigem(lista: any[]) {
    const origem = this.tabelaOrigemCopia();
    const encontrada = origem?.id
      ? lista.find((t) => String(t.id) === String(origem.id))
      : null;
    const id = encontrada?.id ?? origem?.id ?? (lista.length === 1 ? lista[0].id : "");
    const aplicar = () =>
      this.form.controls.tabela.setValue(id === "" || id == null ? "" : id, {
        emitEvent: false,
      });
    aplicar();
    setTimeout(aplicar);
  }

  private preencherTabelaCopia(listaApi?: any[]) {
    const origem = this.tabelaOrigemCopia();
    const lista = this.normalizarListaTabelas(listaApi);
    if (
      origem?.id &&
      !lista.some((t) => String(t.id) === String(origem.id))
    ) {
      lista.unshift(origem);
    }
    this.tabelas = lista;
    this.selecionarTabelaOrigem(lista);
  }

  private carregarTabelasCopia(clienteId: any, filialId?: any, tipoId?: any) {
    this.preencherTabelaCopia(
      this.pedidoService.pedidoCopy?.filial?.tabelas || this.tabelas
    );
    if (!clienteId) {
      return;
    }
    this.usuarioService.getTabelas(
      clienteId,
      (res) => this.preencherTabelaCopia(res),
      filialId ?? "",
      tipoId
    );
  }

  private aplicarListaTabelasDoServico(lista: any[], preferTabelaId?: any) {
    this.tabelas = lista;
    const pref =
      preferTabelaId !== null &&
      preferTabelaId !== undefined &&
      preferTabelaId !== "";
    if (pref) {
      const found = lista.find(
        (t) => String(t.id) === String(preferTabelaId)
      );
      if (found) {
        this.form.controls.tabela.setValue(found.id);
        return;
      }
    }
    if (lista.length === 1) {
      this.form.controls.tabela.setValue(lista[0].id);
    } else {
      this.form.controls.tabela.setValue("");
    }
  }

  private carregarTabelasPreco(
    clienteId: any,
    filialId: any,
    preferTabelaId?: any
  ) {
    if (filialId === "" || filialId === null || filialId === undefined) {
      this.tabelas = [];
      this.form.controls.tabela.setValue("");
      return;
    }
    const key = this.chaveCacheTabelas(clienteId, filialId);
    const cached = this.tabelasPorClienteFilial.get(key);
    if (cached) {
      this.aplicarListaTabelasDoServico(cached.slice(), preferTabelaId);
      return;
    }
    this.usuarioService.getTabelas(
      clienteId,
      (resp) => {
        const lista = resp || [];
        this.tabelasPorClienteFilial.set(key, lista);
        this.aplicarListaTabelasDoServico(lista.slice(), preferTabelaId);
      },
      filialId
    );
  }

  private aplicarDadosClienteAposCarregar(
    resp: any,
    options?: { preferTabelaId?: any; copiaTipoPedido?: { id: any } }
  ) {
    const preferTabela = options?.preferTabelaId;
    const copiaTipo = options?.copiaTipoPedido;
    this.aplicandoDadosCliente = true;
    try {
      this.errorClienteBloqueado = resp.bloqueiaPedidos;
      if (resp.bloqueiaPedidos) {
        this.erroMensagemBloqueio = resp.mensagemBloqueio;
      }

      this.usuarioService.getPedidoTipos(
        function (respPt: any) {
          this.pedidoTiposUsuario = respPt;
          if (this.pedidoTiposUsuario.length == 1) {
            this.form.controls.pedidoTipo.setValue(
              this.pedidoTiposUsuario[0].id
            );
            if (this.isCopy) {
              this.carregarTabelasCopia(
                this.selectedCliente?.id,
                this.form.get("filial")?.value,
                this.pedidoTiposUsuario[0].id
              );
            } else {
              this.usuarioService.getTabelas(this.selectedCliente.id, (res) => {
                this.tabelas = res
                if (res.length === 1) {
                  this.form.controls.tabela.setValue(res[0].id)
                }
              }, "", respPt[0].id);
            }
          } else if (copiaTipo) {
            this.form.controls.pedidoTipo.setValue(copiaTipo.id);
            this.tipoSelecionado = copiaTipo.id;
            if (this.isCopy) {
              this.carregarTabelasCopia(
                this.selectedCliente?.id,
                this.form.get("filial")?.value,
                copiaTipo.id
              );
            }
          } else {
            this.form.controls.pedidoTipo.setValue("");
          }
        }.bind(this)
      );

      this.filiais = resp.filiais;
      this.tabelas = Array.isArray(resp.tabela_preco) ? resp.tabela_preco : [];
      this.filial_Estoque = resp.filial_estoque;
      this.setSelectedCliente(resp);
      this.addCliente(resp);

      if (this.isCopy) {
        this.preencherTabelaCopia(
          this.tabelas.length
            ? this.tabelas
            : this.pedidoService.pedidoCopy?.filial?.tabelas
        );
      }

      if (resp.filiais.length < 2 && resp.filiais.length > 0) {
        this.form.controls.filial.setValue(resp.filiais[0].id, {
          emitEvent: false,
        });
      } else if (this.isCopy && this.pedidoService.pedidoCopy?.filial?.id) {
        const filialOrigemId = this.pedidoService.pedidoCopy.filial.id;
        const temFilial = (resp.filiais || []).some(
          (f) => String(f.id) === String(filialOrigemId)
        );
        this.form.controls.filial.setValue(
          temFilial ? filialOrigemId : "",
          { emitEvent: false }
        );
      } else {
        if (!this.isCopy) {
          this.form.controls.tabela.setValue("");
        }
        this.form.controls.filial.setValue("", { emitEvent: false });
      }

      if (resp.filial_estoque.length < 2 && resp.filial_estoque.length > 0) {
        this.form.controls.filialEstoque.setValue(resp.filial_estoque[0].id);
      } else {
        this.form.controls.filialEstoque.setValue("");
      }
    } finally {
      queueMicrotask(() => {
        this.aplicandoDadosCliente = false;
        this.clienteDetalheCarregando = false;
      });
    }
  }

  onSubmit() {
    if (this.abrindoPedido) {
      return;
    }

    if (this.selectedCliente.cidades.id === null) {
      let msg = $localize`Cidade não encontrada`;
      this.toastService.warning(msg, "", {
        timeOut: 4000,
      });
      return;
    }
    if (!this.listCliente.length) {
      this.error = true;
      this.errorMsg.push($localize`Selecione um ou mais clientes!`);
      return;
    }

    if (this.tabelas.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem tabela de preço!");
      this.toastService.warning($localize`Cliente sem ${this.SITE.labelTabela} de preço!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("tabela").value === "") {

      this.toastService.warning($localize`Selecione uma ${this.SITE.labelTabela}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    if (this.filiais.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem filial!");
      this.toastService.warning($localize`Cliente sem ${this.SITE.labelFilial}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("filial").value === "") {
      this.toastService.warning($localize`Selecione uma ${this.SITE.labelFilial}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    if (this.pedidoTiposUsuario.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem filial!");
      this.toastService.warning($localize`Cliente sem ${this.SITE.labelFilial}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("pedidoTipo").value === "") {
      this.toastService.warning($localize`Selecione uma um ${this.SITE.labelPedidoTipo}!`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    // if (!this.form.valid) {
    //   this.error = true;
    //   this.errorMsg = "Confira o formulário corretamente!";
    //   return;
    // }

    if (this.clienteIdErp[this.selectedCliente.id] === "") {
      this.toastService.warning($localize`Escolha um endereço`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
    }

    if (
      (this.filial_Estoque === "" || this.filial_Estoque.length === 0) &&
      this.initProvider.usaFilialEstoque
    ) {
      this.toastService.warning($localize`Cliente sem filial de estoque`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      return;
    } else if (
      this.form.get("filialEstoque").value === "" &&
      this.initProvider.usaFilialEstoque
    ) {
      this.toastService.warning($localize`Selecione uma filial de estoque`, $localize`Cliente`, {
        positionClass: "toast-bottom-right",
      });
      return;
    }

    if (
      this.form.valid &&
      !this.pedidoService.loading &&
      this.clienteIdErp[this.selectedCliente.id] !== ""
    ) {
      let filialId = this.form.get("filial").value;
      let tabelaId = this.form.get("tabela").value;
      let pedidoTipoId = this.form.get("pedidoTipo").value;
      let filialEstoqueId = this.form.get("filialEstoque").value;
      let pedidoClientes: OrderClient[] = [];
      let dataEntrega = "";
      if (this.SITE.mostraDataEntrega) {
        dataEntrega = formatDate(
          this.form.get("dataEntrega").value,
          "dd/MM/yyyy",
          "en"
        );
      }
      this.listCliente.forEach((c) => {
        pedidoClientes.push({
          idEnderecoErp: this.clienteIdErp[c.id],
          cliente: c.id,
          quantidade: 0,
          subtotal: 0,
          impostos: 0,
          acrescimo: 0,
          acrescimoPercent: 0,
          desconto: 0,
          descontoPercent: 0,
          total: 0,
        });
      });
      let formPedido = {
        clientes: pedidoClientes,
        filial: filialId,
        tabela: tabelaId,
        tipo: pedidoTipoId,
        dataEntrega: dataEntrega,
        filialEstoque: this.initProvider.usaFilialEstoque
          ? filialEstoqueId
          : null,
      };
      this.abrindoPedido = true;
      this.pedidoService.abrir(
        formPedido,
        function (resp) {
          this.pedidoService.select(resp);
          Swal.fire($localize`Pedido`, $localize`Aberto com sucesso!`, "success");

          if (
            this.pedido !== undefined &&
            Configuracoes.modoVisualizacaoCatalogo
          )
            window.localStorage.setItem(
              "visualizacaoModo",
              Configuracoes.modoVisualizacaoCatalogo
            );

          this.router.navigate(["/catalogo"]).finally(() => {
            this.abrindoPedido = false;
          });
          // this.logService.orderCreated(resp.id);
        }.bind(this),
        function (error) {
          this.abrindoPedido = false;
          if (error.status == 403) {
            //403 Forbidden
            let msg = $localize`Usuário não autenticado`;
            this.toastService.info(msg, "", {
              timeOut: 4000,
            });
            window.location.href = "/login";
            return
          }
          if (error.status) {
            this.toastService.error(error.error.detail, $localize`Produto`, {
              positionClass: "toast-bottom-left",
            });
          }
          let obj = JSON.parse(error._body);
          if (obj && obj.msg) {
            this.error = true;
            this.errorMsg = obj.msg;
          }
          if (obj && obj.detail) {
            this.error = true;
            this.errorMsg = [obj.detail];
          }
        }.bind(this)
      );
    }
  }

  async onCopySubmit() {
    if (this.abrindoPedido) {
      return;
    }

    try {
      // 🔹 Helper para mostrar warning e retornar falso
      const warn = (msg: string, title: string = $localize`Cliente`) => {
        this.toastService.warning(msg, title, { positionClass: "toast-bottom-right", timeOut: 4000 });
        return false;
      };

      const pedidoCopy = this.pedidoService.pedidoCopy;
      const clienteCopy = pedidoCopy?.clientes?.[this.pedidoService.index];
      const clienteCopyId = clienteCopy?.cliente?.id;

      if (!clienteCopyId) {
        return warn($localize`Cliente da cópia não encontrado`);
      }

      // const clienteSelecionadoCopy = this.listCliente.find(
      //   (c) => String(c.id) === String(clienteCopyId)
      // );

      if (!this.listCliente.length) return warn($localize`Selecione um ou mais clientes!`);

      // if (!clienteSelecionadoCopy) {
      //   return warn($localize`Cliente da cópia não encontrado`);
      // }

      // this.listCliente = [clienteSelecionadoCopy];
      this.selectedCliente = this.listCliente[0];
      // 🔹 Validações iniciais
      // return
      if (
        !this.selectedCliente?.cidade?.id &&
        !this.selectedCliente?.cidades?.id
      ) {
        return warn($localize`Cidade não encontrada`);
      }


      if (this.tabelas.length < 1) {
        warn($localize`Cliente sem ${this.SITE.labelTabela} de preço!`);
      } else if (!this.form.get("tabela")?.value) {
        return warn($localize`Selecione uma ${this.SITE.labelTabela}!`);
      }

      if (this.filiais.length < 1) {
        warn($localize`Cliente sem ${this.SITE.labelFilial}!`);
      } else if (!this.form.get("filial")?.value) {
        return warn($localize`Selecione uma ${this.SITE.labelFilial}!`);
      }

      if (this.pedidoTiposUsuario.length < 1) {
        warn($localize`Cliente sem ${this.SITE.labelPedidoTipo}!`);
      } else if (!this.form.get("pedidoTipo")?.value) {
        return warn($localize`Selecione um ${this.SITE.labelPedidoTipo}!`);
      }

      if (!this.clienteIdErp[this.selectedCliente.id]) {
        return warn($localize`Escolha um endereço`);
      }

      if (this.initProvider.usaFilialEstoque) {
        if (!this.filial_Estoque?.length) {
          return warn($localize`Cliente sem filial de estoque`);
        }
        if (!this.form.get("filialEstoque")?.value) {

          return warn($localize`Selecione uma filial de estoque`);
        }
      }

      if (!this.form.valid || this.pedidoService.loading) {
        return warn($localize`Confira o formulário corretamente!`);
      }

      const dataEntrega = this.dataEntregaIso();
      const observacao = (this.form.get("observacao")?.value || "").trim();
      const formPedido = {
        pedido_origem_id: Number(pedidoCopy.id),
        pedidos: this.listCliente.map((c) => {
          const item: any = {
            cliente_id: Number(c.id),
            orcamento: false,
            idEnderecoErp: Number(this.clienteIdErp[c.id] || 0),
            tipo_id: Number(this.form.get("pedidoTipo")?.value),
            filial_id: Number(this.form.get("filial")?.value),
            tabela_id: Number(this.form.get("tabela")?.value),
            observacao,
          };
          if (dataEntrega) {
            item.data_entrega = dataEntrega;
          }
          return item;
        }),
      };
      this.abrindoPedido = true;
      this.pedidoService.abrirCopy(
        formPedido,
        (resp) => {
          const novoPedidoId = this.idPedidoDaCopia(resp);
          if (!novoPedidoId) {
            this.abrindoPedido = false;
            this.toastService.error(
              $localize`Pedido copiado, mas o identificador não foi retornado.`,
              $localize`Pedido`
            );
            return;
          }
          this.pedidoService.getPedidoId(novoPedidoId, (pedido) => {
            this.pedidoService.select(pedido);
            Swal.fire($localize`Pedido`, $localize`Aberto com sucesso!`, "success");

            if (Configuracoes.modoVisualizacaoCatalogo) {
              window.localStorage.setItem("visualizacaoModo", Configuracoes.modoVisualizacaoCatalogo);
            }

            this.router.navigate(["/catalogo"]).finally(() => {
              this.abrindoPedido = false;
            });
          });
        },
        (error) => {
          this.abrindoPedido = false;
          if (error.status === 403) {
            this.toastService.info($localize`Usuário não autenticado`, "", { timeOut: 4000 });
            window.location.href = "/login";
            return;
          }

          const mensagem = this.mensagemErroCopia(error);
          this.error = true;
          this.errorMsg = [mensagem];
          this.toastService.error(mensagem, $localize`Pedido`, {
            positionClass: "toast-bottom-right",
          });
        }
      );
    } catch (e) {
      this.abrindoPedido = false;
      this.toastService.error($localize`Erro inesperado`, $localize`Pedido`);
      console.error("Erro onCopySubmit:", e);
    }
  }

  private dataEntregaIso(): string {
    const raw = this.form.get("dataEntrega")?.value;
    if (!raw) {
      return "";
    }
    try {
      return formatDate(raw, "yyyy-MM-dd", "en");
    } catch {
      return "";
    }
  }

  private mensagemErroCopia(error: any): string {
    const detail = error?.error?.detail ?? error?.error ?? error?.detail;
    if (typeof detail === "string" && detail.trim()) {
      return detail;
    }
    if (detail?.mensagem) {
      return detail.mensagem;
    }
    if (typeof error?._body === "string") {
      try {
        const obj = JSON.parse(error._body);
        if (typeof obj?.detail === "string" && obj.detail.trim()) {
          return obj.detail;
        }
        if (obj?.detail?.mensagem) {
          return obj.detail.mensagem;
        }
        if (obj?.msg) {
          return Array.isArray(obj.msg) ? obj.msg.join(" ") : obj.msg;
        }
      } catch {
        return error._body;
      }
    }
    return $localize`Erro inesperado no servidor`;
  }

  private pedidoDaCopia(resp: any): any {
    if (!resp) {
      return null;
    }
    if (resp.id) {
      return resp;
    }
    if (Array.isArray(resp) && resp[0]) {
      return resp[0];
    }
    if (resp.pedidos?.[0]) {
      return resp.pedidos[0];
    }
    return resp.pedido || null;
  }

  private idPedidoDaCopia(resp: any): number | null {
    const pedido = this.pedidoDaCopia(resp);
    const id =
      resp?.grupo_id ??
      pedido?.grupo_id ??
      pedido?.id ??
      resp?.id;
    const n = Number(id);
    return Number.isFinite(n) && n > 0 ? n : null;
  }


  onSelect(event: TypeaheadMatch): void {
    const item = event.item;
    delete item.bloqueiaPedidos;
    this.selecionaCliente(event.item);
  }

  selecionaCliente(cliente: any) {
    this.errorClienteTabela = false;
    this.errorClienteBloqueado = false;
    if (cliente.bloqueiaPedidos) {
      this.errorClienteBloqueado = true;
    }

    this.clienteIdErp[cliente.id] = cliente.idEnderecoErp
      ? cliente.idEnderecoErp + ""
      : "";

    if (this.clienteDetalhadoEmMemoria(cliente)) {
      this.tabelas = [];
      this.form.controls.tabela.setValue("");
      this.aplicarDadosClienteAposCarregar(cliente);
      $("#cliente").val("");
      return;
    }

    this.clienteDetalheCarregando = true;
    this.tabelas = [];
    this.form.controls.tabela.setValue("");

    this.usuarioService.getClientesId(
      {
        id_cliente: cliente.id,
        id_usuario: this.initProvider.usuario.id,
      },
      (resp) => {
        this.aplicarDadosClienteAposCarregar(resp);
      }
    );
    $("#cliente").val("");
  }

  selecionaClienteCopy(cliente: any) {
    this.errorClienteTabela = false;
    this.errorClienteBloqueado = false;
    if (cliente.bloqueiaPedidos) {
      this.errorClienteBloqueado = true;
    }

    this.clienteIdErp[cliente.id] = cliente.idEnderecoErp
      ? cliente.idEnderecoErp + ""
      : "";

    const copiaTipo = this.pedidoService.pedidoCopy?.tipo;
    const tabelaOrigemId = this.pedidoService.pedidoCopy?.tabela?.id;

    if (this.clienteDetalhadoEmMemoria(cliente)) {
      this.tabelas = [];
      this.form.controls.tabela.setValue("");
      this.aplicarDadosClienteAposCarregar(cliente, {
        copiaTipoPedido: copiaTipo,
        preferTabelaId: tabelaOrigemId,
      });
      $("#cliente").val("");
      return;
    }

    this.clienteDetalheCarregando = true;
    this.tabelas = [];
    this.form.controls.tabela.setValue("");

    this.usuarioService.getClientesId(
      {
        id_cliente: cliente.id,
        id_usuario: this.initProvider.usuario.id,
      },
      (resp) => {
        this.aplicarDadosClienteAposCarregar(resp, {
          copiaTipoPedido: copiaTipo,
          preferTabelaId: tabelaOrigemId,
        });
      }
    );
    $("#cliente").val("");
  }

  setSelectedCliente(c: any) {
    if (c.enderecos.length === 1) {
      this.clienteIdErp[c.id] = c.enderecos[0].id;
    }
    this.selectedCliente = c;
  }

  excluiCliente(c: any) {
    this.invalidarCacheTabelasCliente(c.id);
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) {
        this.listCliente.splice(i, 1);
        break;
      }
    }
    if (this.selectedCliente && this.selectedCliente.id == c.id) {
      if (this.listCliente.length) {
        this.selectedCliente = this.listCliente[this.listCliente.length - 1];
      } else {
        this.selectedCliente = null;
        this.clienteDetalheCarregando = false;
        this.tabelas = [];
        this.form.controls.tabela.setValue("");
      }
    }
    this.filiais = [];
  }

  excluiClienteCopy(c: any) {
    this.invalidarCacheTabelasCliente(c.id);
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) {
        this.listCliente.splice(i, 1);
        break;
      }
    }
    if (this.selectedCliente && this.selectedCliente.id == c.id) {
      if (this.listCliente.length) {
        this.selectedCliente = this.listCliente[this.listCliente.length - 1];
      } else {
        this.selectedCliente = null;
        this.clienteDetalheCarregando = false;
        this.tabelas = [];
        this.form.controls.tabela.setValue("");
      }
    }
  }

  addCliente(c: any) {
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) return;
    }
    this.listCliente.push(c);
  }
  selectTipo(e) {
    localStorage.setItem("tipoPedidoPre", e.target.value);
  }
  selecionaFilial(idFilial: any) {
    if (this.aplicandoDadosCliente) {
      return;
    }
    const fid =
      idFilial === null || idFilial === undefined ? "" : String(idFilial);
    if (fid === "") {
      this.tabelas = [];
      this.form.controls.tabela.setValue("");
      return;
    }
    let filial: any;
    for (var i = 0; i < this.filiais.length; i++) {
      if (String(this.filiais[i].id) === fid) {
        filial = this.filiais[i];
        break;
      }
    }
    if (!filial || !this.selectedCliente?.id) {
      return;
    }
    if (this.isCopy) {
      this.carregarTabelasCopia(
        this.selectedCliente.id,
        filial.id,
        this.form.get("pedidoTipo")?.value
      );
      return;
    }
    this.carregarTabelasPreco(this.selectedCliente.id, filial.id);
  }

  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
  }

  getTabela(event) {
    if (!this.selectedCliente?.id) {
      return;
    }
    if (this.isCopy) {
      this.carregarTabelasCopia(
        this.selectedCliente.id,
        this.form.get("filial")?.value,
        event
      );
      return;
    }
    this.usuarioService.getTabelas(this.selectedCliente.id, (res) => {
      this.tabelas = res
      if (res.length === 1) {
        this.form.controls.tabela.setValue(res[0].id)
      }
    }, "", event);
  }

  ngOnInit() {
    this.form
      .get("filial")
      .valueChanges.pipe(filter(() => !this.aplicandoDadosCliente))
      .subscribe((v) => this.selecionaFilial(v));
    if (this.initProvider.inicializaPedido) {
      this.toastService.warning("Usuário sem permissão para criar pedido", "Pedido")
      this.router.navigate(["/"]);
    }
    if (localStorage.getItem("tipoUsuario") === "PAINEL") {
      this.location.back();
    }
    if (!this.isCopy) {
      if (
        !this.pedidoService.confirmaAbandonarPedidoEmAberto()) {
        this.location.back();
      }
    } else {

      if (this.pedidoService.pedidoCopy === undefined) {
        this.router.navigate(["/pedidos"]);
        return;
      }
      this.preencherTabelaCopia(
        this.pedidoService.pedidoCopy?.filial?.tabelas
      );
      const clienteCopy = this.pedidoService.pedidoCopy.clientes[this.pedidoService.index];
      const clienteCopyId = clienteCopy?.cliente?.id;
      if (!clienteCopyId) {
        this.router.navigate(["/pedidos"]);
        return;
      }
      this.usuarioService.getClientesId(
        {
          id_cliente: clienteCopyId,
          id_usuario: this.initProvider.usuario.id,
        },
        (resp) => {
          this.errorClienteBloqueado = resp.bloqueiaPedidos;
          if (resp.bloqueiaPedidos) {
            this.erroMensagemBloqueio = resp.mensagemBloqueio
          }
          this.usuarioService.getPedidoTipos(
            function (respPt) {
              this.pedidoTiposUsuario = respPt;
              if (this.pedidoTiposUsuario.length == 1) {
                this.form.controls.pedidoTipo.setValue(
                  this.pedidoTiposUsuario[0].id
                );
              } else {
                this.form.controls.pedidoTipo.setValue(this.pedidoService.pedidoCopy.tipo.id);
                this.tipoSelecionado = this.pedidoService.pedidoCopy.tipo.id
              }
            }.bind(this)
          );
          this.filiais = resp.filiais;
          this.filial_Estoque = resp.filial_estoque;
          this.setSelectedCliente(resp);
          this.listCliente = [resp];
          const obsCopy = this.pedidoService.pedidoCopy?.observacao;
          if (this.form.get("observacao") && obsCopy) {
            this.form.controls.observacao.setValue(obsCopy);
          }

          const filialCopyId = this.pedidoService.pedidoCopy.filial.id;
          const tipoCopyId = this.pedidoService.pedidoCopy.tipo.id;

          this.aplicandoDadosCliente = true;
          try {
            this.form.controls["filial"].setValue(filialCopyId, {
              emitEvent: false,
            });
            this.form.controls.pedidoTipo.setValue(tipoCopyId);
            this.tipoSelecionado = tipoCopyId;
            this.preencherTabelaCopia(
              this.pedidoService.pedidoCopy?.filial?.tabelas
            );
          } finally {
            queueMicrotask(() => {
              this.aplicandoDadosCliente = false;
            });
          }
          this.carregarTabelasCopia(resp.id, filialCopyId, tipoCopyId);
        }
      );
    }
  }
}
